import type React from "react";
import { Box, Typography, Avatar, Paper, Grid, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

interface BelovedDetails {
  name?: string;
  person_image?: string;
  second_name?: string;
  dateOfBirth?: string;
  dateOfDeath?: string;
  gender?: string;
  nickname?: string;
  religion?: string;
  denomination?: string;
  [key: string]: unknown;
}

interface BelovedCardProps {
  name: string;
  avatar: string;
  details: BelovedDetails;
}

const BelovedCard: React.FC<BelovedCardProps> = ({ name, avatar, details }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const formatValue = (value: unknown) => {
    if (value === null || value === undefined || value === "") {
      return "N/A";
    }
    return typeof value === "string" ? value : String(value);
  };

  return (
    <Paper sx={{ p: 2, height: "100%", boxShadow: 0 }}>
      <Typography variant="h6" sx={{ fontSize: 16 }}>
        Beloved&apos;s Information
      </Typography>
      <Box mt={2} display="flex" alignItems="center">
        <Avatar src={avatar} sx={{ width: 56, height: 56, mr: 2 }} />
        <Typography variant="h6" fontWeight="bold">
          {name}
        </Typography>
      </Box>
      <Grid container spacing={1} mt={1}>
        {Object.entries(details).map(([label, value]) => (
          <Grid size={{ xs: 6 }} key={label}>
            <Typography variant="caption" sx={{ color: colors.primary[300] }}>
              {label.charAt(0).toUpperCase() + label.slice(1)}
            </Typography>
            <Typography>{formatValue(value)}</Typography>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default BelovedCard;
